/**
 * Shared gate for advancing main/portal presentation authority only after the
 * on-air surface shows the expected plan frame (#1479).
 */
export function shouldRecordPresentationAfterVisibleCommit(input: {
  planIdx: number
  planLength: number
  expectedFrameId: string | null | undefined
  targetFrameId: string | null | undefined
  surfaceFrameId: string | null | undefined
  lastLoggedPlanIdx: number
  /** True while `commitPlaybackSurface` deferred apply into pending asset-index work. */
  commitDeferredToPending?: boolean
}): boolean {
  const {
    planIdx,
    planLength,
    expectedFrameId,
    targetFrameId,
    surfaceFrameId,
    lastLoggedPlanIdx,
    commitDeferredToPending
  } = input
  if (commitDeferredToPending === true) {
    return false
  }
  if (planIdx < 0 || planIdx >= planLength) {
    return false
  }
  if (expectedFrameId == null || expectedFrameId === '') {
    return false
  }
  if (targetFrameId !== expectedFrameId || surfaceFrameId !== expectedFrameId) {
    return false
  }
  if (planIdx === lastLoggedPlanIdx) {
    return false
  }
  return true
}
